<!--suppress CssUnresolvedCustomProperty -->
<template>
    <div class="container-require">
        <div class="main_color white--txt block_init_tramite" v-if="windowWidth >= 741">
            <v-icon
            class="main_color white--text" 
            :size="windowWidth < 741 ? '50' : '150' "> <!-- 150 -->
                mdi-chart-donut
            </v-icon>

            <v-card outlined color="transparent">
                <v-card-title class="text-h4 font-weight-black" style="color: white; margin: 10px 0; word-break: normal">
                    {{ $route.params.processName}}
                </v-card-title>
                <v-card-subtitle class="text-h5" style="color: white; margin: 10px 0; word-break: normal">
                    Descripcion del proceso que se tramita se pone aqui
                </v-card-subtitle>
                <v-card-actions>
                    <v-btn :to="{name: 'procedure_create', params: {processId: $route.params.processId}}" style="background: white" x-large color="main_color" text outlined>
                        Iniciar Trámite
                    </v-btn>
                </v-card-actions>
            </v-card>
        </div>
        <div class="main_color white--txt block_init_tramite" v-else>
            <div style="display: flex">
                <v-icon
                class="main_color white--text" 
                :size="windowWidth < 741 ? '50' : '150' "> <!-- 150 -->
                    mdi-chart-donut
                </v-icon>
                <div class="text-h5 font-weight-black white--text" style="color: white; margin: 10px 10px; word-break: normal">
                    {{ $route.params.processName}}
                </div>
            </div>
            <div class="text-h6" style="color: white; margin: 10px 0; word-break: normal">
                Descripcion del proceso que se tramita se pone aqui
            </div>
            <v-btn  :to="{name: 'procedure_create', params: {processId: $route.params.processId}}" style="background: white" large color="main_color" text outlined>
                Iniciar Trámite
            </v-btn>
        </div>
        <v-card class="container-tabs">
            <div class="flex">
                <v-chip v-for=" (tab, index) in processesStore.processRequirements" :key="index" 
                @click="changeTab('requisitos', index)" label large 
                style="margin: 5px 5px; cursor: pointer;" class="pa-2 font-weight-bold"
                :class="window == index ? 'main_color_action white--text': 'main_color--text'">
                    {{tab.title}}
                </v-chip>
            </div>

            <div style="max-width: 520px; margin: 0 25px 0 25px">
                <v-divider></v-divider>
            </div>

            <v-window v-model="window" horizontal>
                <v-window-item v-for="tab in processesStore.processRequirements" :key="tab.id">
                    <v-card flat v-html="tab.content" style="padding: 15px">
                    </v-card>
                </v-window-item>
            </v-window>
        </v-card>
    </div>
<!--   TABLE FOR PROCESSES (TABLETS AND PC)   -->
    <!-- <div class="bg_main">
        <v-row>
            <v-col cols="12">
                <v-card class="py-2 px-4">

                    <v-card-title class="text-center primary--text justify-center">
                        Información General del Trámite
                    </v-card-title>

                    <v-divider class="mt-2 mb-4"></v-divider>

                    <v-card-text class="text-center">
                        <v-card-subtitle class="text-h6 secondary--text">Para iniciar tu trámite, haz click aquí:</v-card-subtitle>
                        <v-btn :to="{name: 'procedure_create', params: {processId: $route.params.processId}}" color="primary">
                                {{ $route.params.processName}}
                        </v-btn>
                        <v-container>
                            <v-card-subtitle class="hidden-md-and-up text-h6">
                                {{ $route.params.processName}}
                            </v-card-subtitle>

                            <div class="text-left my-4">
                                A continuación ponemos a tu disposición información relacionada con el trámite a manera de pestañas.
                                Para ver la información de la sección de tu interés, haz clic en la pestaña correspondiente y lee detenidamente su contenido.
                            </div>

                            <div class="text-left">
                                <b>IMPORTANTE:</b> Si deseas realizar este trámite, haz clic en el botón de arriba y sigue las instrucciones conforme se vayan solicitando al avanzar tu trámite.
                            </div>
                        </v-container>
                    </v-card-text>

                    <v-divider class="mt-2 mb-4"></v-divider>
                    <v-container>
                        
                        <v-tabs v-model="tab" show-arrows grow>
                            <v-tabs-slider class="divisor_bajo" color=""></v-tabs-slider>
                            <v-tab v-for=" tab in processesStore.processRequirements" :key="tab.id">
                                <span class="numero_requisitos mr-2">
                                    {{tab.position}}
                                </span>
                                <span>{{ tab.title }}</span>
                                <span class="flecha_divisor">></span>
                            </v-tab>
                        </v-tabs>
                        <v-tabs-items v-model="tab">
                            <v-tab-item v-for="tab in processesStore.processRequirements" :key="tab.id">
                                <v-card color="basil" flat>
                                    <v-card-text v-html="tab.content"></v-card-text>
                                </v-card>
                            </v-tab-item>
                        </v-tabs-items>
                    </v-container>

                </v-card>
            </v-col>
        </v-row>
    </div> -->
<!-- END TABLE FOR PROCESSES   -->
</template>

<script>
import {mapState, mapActions, mapGetters} from 'vuex';
import {processRequirementsRequest} from "../api/models";

export default {
    name: "ProcessRequirements",
    components: {
    },
    computed: {
        ...mapState({account:state => state.account, processesStore: state => state.processes}),
    },
    created() {
        window.addEventListener("resize", this.resizeWindow);
    },
    destroyed() {
        window.removeEventListener("resize", this.resizeWindow);
    },
    data() {
        return {
            tab: null,
            tabInitProceso: 'requisitos',
            window: 0,
            totalWindows: 4,
            windowWidth: window.innerWidth
        }
    },

    watch: {
        '$store.state.account.user'(){
            if (this.account.loggedIn){
                this.getRequirements()
            }
        },

        '$store.state.processes.processRequirements'(prerequirements){
            if (prerequirements && this.isGuestUser){
                this.verifyGuestUser()
            }
        }
    },

    mounted() {
        this.checkAuthentication()
    },

    methods: {
        ...mapActions('processes', ['getProcessRequirements']),
        ...mapActions('account', ['login', 'logout']),
        ...mapActions('alerts', ['error']),
        ...mapGetters('account', ['isGuestUser']),

        resizeWindow(e){
            this.windowWidth = e.target.innerWidth
        },

        changeTab(tab, w){
            this.tabInitProceso = tab
            this.window = w
        },

        getRequirements(){
            let request = processRequirementsRequest()
            request.processId = this.$route.params.processId
            request.userId = this.account.user.id

            //Call from VueX
            this.getProcessRequirements(request)
        },

        checkAuthentication(){
            if (this.account.loggedIn){
                this.getRequirements();
            }else{
                let isInvited = this.$router.currentRoute.query.invited == 1

                if (isInvited){
                    this.requestLoginAsInvited()
                }else {
                    this.$router.push({name: 'login'})
                }
            }
        },

        requestLoginAsInvited(){
            let request = {username: process.env.VUE_APP_INVITED_USERNAME, password:  process.env.VUE_APP_INVITED_PASSWORD}
            this.login(request)

        },

        verifyGuestUser(){
            if (!this.processesStore.processRequirementsShow){
                this.error(this.processesStore.processRequirements[0].content)
                this.logout()
            }
        },

        //TODO: $response->show = false; after get prerequisites
    },
}
</script>

<style scoped>
    .container-tabs{
        max-width: 60%;
        width: 60%;
    }
    .container-require{
        display: flex;
    }
    .block_init_tramite{
        min-height: 500px;
        max-height: 89vh;
        height: 89vh;
        padding: 10vh 10px 10px 3vw; 
        border-radius: 30px;
        width: 25vw;
        min-width: 400px;
        max-width: 40vw;
        margin: 0 10px; 
        box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%); 
    }
    .numero_requisitos{
        background-color: rgba(0, 0, 0, 0.20);
        padding: 5px 8px;
        margin-left: -30px;
    }

    .v-tab--active .numero_requisitos{
        color: var(--v-primary-base);
        background-color: var(--v-primary-lighten5);
    }

    .v-tab--active .flecha_divisor{
        color: var(--v-primary-base);
    }

    .flecha_divisor{
        color: rgba(0, 0, 0, 0.40);
        margin-left: 30px;
        margin-right: -70px;
    }

    .v-tab:last-child .flecha_divisor{
        display: none;
    }

    .divisor_bajo{
        display: none !important;
    }

    @media (max-width: 740px) {
        .container-require{
            display:inline-block;
        }
        .block_init_tramite{
            min-height: auto;
            max-height: auto;
            height: auto;
            padding: 1vh 4vw 10px 4vw; 
            border-radius: 30px;
            width: 100%;
            min-width: 350px;
            max-width: 100vw;
            margin: 0 0 10px 0; 
            box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%); 
        }
        .container-tabs{
            max-width: 100%;
            width: 100%;
        }
    }
</style>